import { Dictionary } from '../../../type_definitions/vendor';
import { Type } from '@angular/core';
import { LocalWebshopSettingsComponent } from './local-webshop-settings/local-webshop-settings.component';
import { STATE_REPORT } from '@app/shared/app-states';
import { ReportParameterCode, ReportParameterShortCode } from '@app/main/report/report-state.util';
import { IObject } from '@type_definitions/datatypes';

export interface IUploadConfig {
  title:string; // title will be used for wizard step one
  component:Type<any>; // this will be displayed in wizard step one
  sectionTitle:string; // this will be displayed in step one section title
  uploadTemplateCode:string; // this will be used to fetch example template
  downloadDataUrl?: { // this will be used to fetch example template including the data
    stateName:string;
    stateParams:IObject;
  } 
}

export const UPLOAD_CONFIG:Dictionary<IUploadConfig> = {
  WS_LOCAL: {
    title: 'GA.GENERAL.WEBSHOP',
    component: LocalWebshopSettingsComponent,
    sectionTitle: 'GA.UPLOADS.WS_LOCAL',
    uploadTemplateCode: 'WS_LOCAL_ORIGINAL',
    downloadDataUrl: {
      stateName: STATE_REPORT, 
      stateParams: {
        [ReportParameterCode.REPORT_ID]: 175, 
        [ReportParameterShortCode.SHOW_FILTERS] : true,
        [ReportParameterShortCode.EXPORT_TEMPLATE]: 'DOWNLOAD_LOCAL_WEBSHOP_SETTINGS'
      }
    }    
  }
};